import { motion } from "framer-motion";
import { MEDIA } from "../lib/media";

export const AboutSection = () => {
  return (
    <section id="nosotros" data-testid="about-section" className="py-24 md:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
          >
            <p className="overline text-[#A25F4B] mb-4">Nuestra historia</p>
            <h2
              data-testid="about-title"
              className="font-heading text-4xl md:text-5xl tracking-tight leading-tight text-[#2D2A26] mb-8"
            >
              Una experiencia{" "}
              <span className="italic font-light">única</span>
            </h2>
            <div className="space-y-5 text-[#5C5750] text-base md:text-lg leading-relaxed font-body">
              <p>
                En el corazón colonial de Suchitoto, Suchimex nace como un espacio donde la auténtica gastronomía
                mexicana se encuentra con la calidez salvadoreña. Cada plato cuenta una historia de sabores,
                tradición y pasión por lo que hacemos.
              </p>
              <p>
                Más allá de una comida inolvidable, te ofrecemos un lugar para descansar. Nuestras instalaciones
                están pensadas para que tu visita se convierta en una escapada completa: buena comida, buenas
                bebidas y el mejor descanso.
              </p>
            </div>
            <div className="flex gap-4 mt-10">
              <a
                href="#restaurante"
                data-testid="about-cta-restaurante"
                className="overline text-[0.7rem] bg-[#3F4F34] text-[#FAF7F2] px-8 py-3 hover:bg-[#2B3822] transition-all duration-300 hover:-translate-y-0.5"
              >
                Conoce más
              </a>
            </div>
          </motion.div>

          {/* Video */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative aspect-[4/5] overflow-hidden"
          >
            <video
              data-testid="about-video"
              autoPlay
              muted
              loop
              playsInline
              className="absolute inset-0 w-full h-full object-cover"
            >
              <source src={MEDIA.ambianceVideo} type="video/mp4" />
            </video>
            <div className="absolute inset-0 bg-black/5" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
